import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHotel,
  faDollar,
  faStream,
  faPencil,
} from "@fortawesome/free-solid-svg-icons";
import { config } from "../../config";

function Benefits() {
  const benefits = [
    {
      icon: faHotel,
      title: "Effortless Hotel Booking",
      description:
        "Seamless online booking experience with exclusive deals and zero hidden fees.",
    },
    {
      icon: faPencil,
      title: "Customized Options",
      description:
        "Personalized hotel recommendations that cater to diverse budgets and preferences.",
    },
    {
      icon: faStream,
      title: "Streamlined Reservation Process",
      description:
        "User-friendly interface ensuring completely hassle-free reservations anytime, anywhere, from any device.",
    },
    {
      icon: faDollar,
      title: "Secure Payment Methods",
      description:
        "Multiple trusted gateways protect your transactions for safe, worry-free online payments.",
    },
  ];

  return (
    <div className="container mx-auto px-4 py-12 md:py-16">
      <h2 className="text-2xl md:text-3xl font-bold text-center mb-8 md:mb-12">
        Why Book With Us
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
        {benefits.map((benefit, index) => (
          <div
            key={index}
            className="bg-gray-50 rounded-lg p-6 md:p-8 text-center shadow-sm hover:shadow-md transition-shadow"
          >
            <div
              className={`w-12 h-12 md:w-16 md:h-16 ${config.primaryColorBg} bg-opacity-10 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6`}
            >
              <FontAwesomeIcon
                icon={benefit.icon}
                className={`${config.primaryColorText} text-xl md:text-2xl`}
              />
            </div>
            <h3 className="text-lg md:text-xl font-bold mb-2 md:mb-3">
              {benefit.title}
            </h3>
            <p className="text-sm md:text-base text-gray-600">
              {benefit.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Benefits;
